<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/project' }"
                >项目管理</el-breadcrumb-item
            >
            <el-breadcrumb-item>记录项目成果</el-breadcrumb-item>
        </el-breadcrumb>
        <div
            class="content-box pro-detail__wraper"
            style="padding-bottom: 1px;"
        >
            <div class="table" style="padding: 20px">
                <el-table :data="data" :border="true" :stripe="true">
                    <el-table-column
                        prop="create_time"
                        align="center"
                        label="创建时间"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="项目名称"
                    >
                    </el-table-column>
                    <el-table-column prop="no" align="center" label="项目编号">
                    </el-table-column>
                    <el-table-column
                        prop="company"
                        align="center"
                        label="商户名称"
                    >
                    </el-table-column>
                    <el-table-column align="center" label="需求数量">
                        <template slot-scope="scope">
                            {{ scope.row.service.length }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="eva-form">
                <div
                    class="eva-form__item text-area__box"
                    style="align-items: stretch"
                >
                    <div class="label">记录成果</div>
                    <div class="text-wrapper">
                        <el-input
                            type="textarea"
                            :rows="10"
                            placeholder="请记录成果"
                            v-model="formItem.content"
                        >
                        </el-input>
                    </div>
                </div>
                <div
                    class="eva-form__item text-area__box"
                    style="align-items: stretch"
                >
                    <div class="label">成果附件</div>
                    <div class="text-wrapper">
                        <el-upload
                            list-type="text"
                            name="image"
                            :headers="headers"
                            :on-success="uploadSuccess"
                            :on-remove="handleRemove"
                            multiple
                            :limit="9"
                            :on-exceed="handleExceed"
                            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                            :action="actionUrl"
                        >
                            <i class="iconfont icon-shangchuanwenjian"></i>
                        </el-upload>
                    </div>
                </div>
                <div class="eva-form__item text-area__box">
                    <div class="label"></div>
                    <div class="text-wrapper">
                        <el-button
                            @click="onSubmit"
                            type="primary"
                            style="min-width: 144px; font-size: 14px;"
                            >提交记录</el-button
                        >
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" title="图片预览">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>

<script>
import router from '../../router'
import qs from 'qs'

export default {
    name: 'ProjectRecord',
    data () {
        const headers = { token: localStorage.getItem('token') }
        return {
            headers,
            actionUrl: process.env.VUE_APP_BASE + '/api/fileupload',
            data: [],
            dialogImageUrl: '',
            pics: [],
            dialogVisible: false,
            formItem: {
                content: ''
            }
        }
    },
    mounted () {
        this.getInfo(this.$route.query.id)
    },
    methods: {
        getInfo (id) {
            this.$http
                .get('/api/user/project/info', {
                    params: {
                        id
                    }
                })
                .then(res => {
                    if (res.code === 0) {
                        this.data = [res.data]
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                    // this.$Message.error('网络错误，请稍候再试。');
                })
        },
        handlePictureCardPreview (file) {
            this.dialogImageUrl = file.url
            this.dialogVisible = true
        },
        handleRemove (file) {
            let left = this.pics.filter(item => {
                if (item.uid !== file.uid) {
                    return item
                }
            })
            this.pics = left
        },
        uploadSuccess (res, file) {
            if (res.code === 0) {
                let list = this.pics
                list.push({
                    uid: file.uid,
                    url: res.data.signPath,
                    name: res.data.name,
                    path: res.data.fullpath,
                    status: 'finished'
                })
                this.pics = list
            } else {
                this.$message.error(res.message)
            }
        },
        handleExceed () {
            this.$message.error('附件最多只能上传9个')
        },
        onSubmit () {
            let pics = this.pics.map(item => {
                return {
                    src: item.path,
                    filename: item.name
                }
            })
            if (
                (this.formItem.content.length < 2 ||
                    this.formItem.content.length > 2000) &&
                this.formItem.content.length !== 0
            ) {
                this.$Message.error('请填写2-2000字记录成果')
            } else if (
                pics.length === 0 &&
                this.formItem.content.length === 0
            ) {
                this.$Message.error('成果记录和附件二者必填一项')
            } else {
                this.$http
                    .post(
                        '/api/user/project/projectwork',
                        qs.stringify({
                            id: this.$route.query.id,
                            content: this.formItem.content,
                            pics: JSON.stringify(pics)
                        })
                    )
                    .then(res => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: '项目成果记录已提交'
                            })
                            router.push(
                                `/index/project/detail?id=${res.data.id}`
                            )
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        // this.$Message.error('网络错误，请稍候再试。');
                    })
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/style/sub.scss";
.eva-form {
    font-size: 14px;
    margin-top: 54px;
    padding: 0 20px;
    .eva-form__item {
        margin-bottom: 34px;
    }
    .rates-wrapper {
        display: flex;
        .rate-box {
            display: flex;
            align-items: center;
            width: 280px;
            margin-right: 56px;
        }
    }
    .text-area__box {
        display: flex;
        align-items: center;
        .text-wrapper {
            flex: 1;
        }
    }
    .label {
        position: relative;
        padding-left: 10px;
        margin-right: 20px;
        top: 1px;
        width: 90px;
        text-align: right;
        overflow: hidden;
        .text-warning {
            font-size: 20px;
            position: absolute;
            top: 1px;
            left: 0;
        }
    }
}
</style>
